import { render, staticRenderFns } from "./africanContent.vue?vue&type=template&id=b7e2157e&scoped=true&"
import script from "./africanContent.vue?vue&type=script&lang=js&"
export * from "./africanContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7e2157e",
  null
  
)

export default component.exports